import { TabContent, TabPane } from "reactstrap";
import AllTabs from "./AllTabs";
import PhotosTab from "./PhotosTab";
import { SearchTabsProp } from "../../../../types/Applications";
import VideoTabs from "./VideoTabs";

const SearchTabsContent : React.FC<SearchTabsProp > = ({ activeTab }) => {

  return (

    <TabContent activeTab={activeTab}>
      <TabPane tabId={1} className="search-links">
        <AllTabs />
      </TabPane>
      <TabPane tabId={2}>
        <PhotosTab />
      </TabPane>
      <TabPane tabId={3}>
        <VideoTabs />
      </TabPane>
      <TabPane tabId={4} />
      <TabPane tabId={5} />
    </TabContent>
  );
};

export default SearchTabsContent;